module.exports = __webpack_public_path__ + "img/bg3.5d9c906a.png";